import React from 'react'

const UserProfiles = () => {
  return (
    <div>UserProfiles</div>
  )
}

export default UserProfiles